import { useContext, createContext } from 'react';

// Create a context for dynamic Stripe hooks
export const DynamicStripeContext = createContext({
  useStripe: null,
  useElements: null,
  isLoaded: false,
});

// Custom hook to use dynamically loaded Stripe hooks
export const useDynamicStripe = () => {
  const context = useContext(DynamicStripeContext);

  if (!context.isLoaded || !context.useStripe) {
    return null;
  }

  return context.useStripe();
};

export const useDynamicElements = () => {
  const context = useContext(DynamicStripeContext);

  if (!context.isLoaded || !context.useElements) {
    return null;
  }

  return context.useElements();
};
